function ConfirmVerification(){
    const token = new URLSearchParams(window.location.search).get("token");
    console.log(token);
    window.location = `https://doctriscare.ml/_/#/users/confirm-verification/${token}`;
}

export default ConfirmVerification;